export const MAP_GEOLOCATION_ZOOM = 18;

export const REDIRECT_QUERY_NAME = 'redirect';
